// @ts-ignore
import React from 'react'
import GoogleMe from "../../assets/GoogleMe.png";
import Navbar from '../../components/Navbar';

function GoogleMeSis() {
  <main>
  <title>Googlemesis™ SEO Accelerator | Local & National SEO for Women Experts | Her Growth Co</title>
<meta
name="description"
content="Elevate your Google rankings with our signature Googlemesis program—crafted for women consultants and founders ready to dominate local and niche SEO."
/>
<meta
name="keywords"
content="content marketing austin, seo blog strategy for women, thought leadership content austin, content writing for consultants, austin content creation services, blogging for female-led businesses, digital content strategy texas, content marketing for premium brands, blog calendar seo strategy, lead magnet development, content writing agency austin, long-form content for seo, women entrepreneurs blog writers, austin business blogging experts, social content integration austin, texas content marketing agency, content creation for service businesses, copywriting for niche businesses, content for authority websites, seo copywriting austin, blog content for lead generation, austin content funnel building, content upgrades for coaches, expert content planning texas, personal brand content writing"
/>
</main>
  return (
    <div>
    {/* Banner */}
    
<section className="relative h-[60px]">
  <div className="absolute inset-x-0  mx-auto flex w-full flex-col items-center bg-purple-300 p-4 sm:justify-between  md:flex-row lg:w-full">
    <div className="flex items-center">
      <img src={GoogleMe} alt="Her Growth Co" className="mr-4 inline-block h-8 w-8 rounded-full object-cover" />
      <p>Ut enim odio quis ipsum posuere ante porta nibh nulla.</p>
    </div>

  </div>
</section>



    {/* Navbar */}
    <section>
  <Navbar/>
</section>

    {/* Hero */}
    
<header>

  <div className="mx-auto w-full max-w-7xl overflow-hidden px-5 py-10 md:px-10 lg:px-10 lg:py-10">
    <div className="flex flex-col items-center gap-y-10 py-10 sm:gap-y-10 lg:py-10">
      <div className="max-w-3xl">
        <h1 className="m-5 text-center text-3xl font-bold sm:text-4xl md:text-5xl lg:text-6xl">The Website You Want Without The Dev Time.</h1>
        <p className="mx-auto mb-6 text-center text-sm text-[#636262] sm:px-8 sm:text-xl md:px-24 lg:mb-8">Lorem ipsum dolor sit amet, consectetur adipiscing elit ut aliquam, purus sit amet luctus venenatis, lectus</p>
        <div className="mx-auto flex w-36 flex-col justify-center gap-x-5 gap-y-5 sm:w-full sm:flex-row sm:items-start">
          <a href="/" className="inline-block items-center rounded-md border border-solid border-black bg-black px-6 py-3 text-center font-semibold text-white">Learn more</a>
          <a href="/" className="flex items-center gap-2 rounded-md border border-solid border-black bg-white px-6 py-3 text-center font-semibold text-black">
            <img src="https://assets.website-files.com/6458c625291a94a195e6cf3a/64aa5ac1b81f4f0a9b8f0986_play-icon.svg" alt="" className="inline-block h-4 w-4" />
            <p>Demo</p>
          </a>
        </div>
      </div>
    </div>
  </div>

  <div className="flex min-w-[100vw] gap-2 overflow-hidden sm:gap-3">
    <img src="https://assets.website-files.com/6458c625291a94a195e6cf3a/64aa5caeeb6dff02ed4569b5_fake-photo.png" alt="" className="h-auto w-36 rounded-2xl sm:w-72 lg:w-80" />
    <img src="https://assets.website-files.com/6458c625291a94a195e6cf3a/64aa5caeeb6dff02ed4569b5_fake-photo.png" alt="" className="h-auto w-36 rounded-2xl sm:w-72 lg:w-80" />
    <img src="https://assets.website-files.com/6458c625291a94a195e6cf3a/64aa5caeeb6dff02ed4569b5_fake-photo.png" alt="" className="h-auto w-36 rounded-2xl sm:w-72 lg:w-80" />
    <img src="https://assets.website-files.com/6458c625291a94a195e6cf3a/64aa5caeeb6dff02ed4569b5_fake-photo.png" alt="" className="h-auto w-36 rounded-2xl sm:w-72 lg:w-80" />
    <img src="https://assets.website-files.com/6458c625291a94a195e6cf3a/64aa5caeeb6dff02ed4569b5_fake-photo.png" alt="" className="h-auto w-36 rounded-2xl sm:w-72 lg:w-80" />
    <img src="https://assets.website-files.com/6458c625291a94a195e6cf3a/64aa5caeeb6dff02ed4569b5_fake-photo.png" alt="" className="h-auto w-36 rounded-2xl sm:w-72 lg:w-80" />
    <img src="https://assets.website-files.com/6458c625291a94a195e6cf3a/64aa5caeeb6dff02ed4569b5_fake-photo.png" alt="" className="h-auto w-36 rounded-2xl sm:w-72 lg:w-80" />
    <img src="https://assets.website-files.com/6458c625291a94a195e6cf3a/64aa5caeeb6dff02ed4569b5_fake-photo.png" alt="" className="h-auto w-36 rounded-2xl sm:w-72 lg:w-80" />
    <img src="https://assets.website-files.com/6458c625291a94a195e6cf3a/64aa5caeeb6dff02ed4569b5_fake-photo.png" alt="" className="h-auto w-36 rounded-2xl sm:w-72 lg:w-80" />
    <img src="https://assets.website-files.com/6458c625291a94a195e6cf3a/64aa5caeeb6dff02ed4569b5_fake-photo.png" alt="" className="h-auto w-36 rounded-2xl sm:w-72 lg:w-80" />
    <img src="https://assets.website-files.com/6458c625291a94a195e6cf3a/64aa5caeeb6dff02ed4569b5_fake-photo.png" alt="" className="h-auto w-36 rounded-2xl sm:w-72 lg:w-80" />
    <img src="https://assets.website-files.com/6458c625291a94a195e6cf3a/64aa5caeeb6dff02ed4569b5_fake-photo.png" alt="" className="h-auto w-36 rounded-2xl sm:w-72 lg:w-80" />
    <img src="https://assets.website-files.com/6458c625291a94a195e6cf3a/64aa5caeeb6dff02ed4569b5_fake-photo.png" alt="" className="h-auto w-36 rounded-2xl sm:w-72 lg:w-80" />
    <img src="https://assets.website-files.com/6458c625291a94a195e6cf3a/64aa5caeeb6dff02ed4569b5_fake-photo.png" alt="" className="h-auto w-36 rounded-2xl sm:w-72 lg:w-80" />
    <img src="https://assets.website-files.com/6458c625291a94a195e6cf3a/64aa5caeeb6dff02ed4569b5_fake-photo.png" alt="" className="h-auto w-36 rounded-2xl sm:w-72 lg:w-80" />
    <img src="https://assets.website-files.com/6458c625291a94a195e6cf3a/64aa5caeeb6dff02ed4569b5_fake-photo.png" alt="" className="h-auto w-36 rounded-2xl sm:w-72 lg:w-80" />
    <img src="https://assets.website-files.com/6458c625291a94a195e6cf3a/64aa5caeeb6dff02ed4569b5_fake-photo.png" alt="" className="h-auto w-36 rounded-2xl sm:w-72 lg:w-80" />
    <img src="https://assets.website-files.com/6458c625291a94a195e6cf3a/64aa5caeeb6dff02ed4569b5_fake-photo.png" alt="" className="h-auto w-36 rounded-2xl sm:w-72 lg:w-80" />
  </div>
</header>


    {/* About Us */}
   
<section>
  <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20">
    <div className="grid gap-8 md:grid-cols-2 md:gap-10">
      <img src="https://assets.website-files.com/6458c625291a94a195e6cf3a/64b7a30c42421ae3cbe5abb9_about%20image.svg" alt="" className="inline-block h-full w-full rounded-2xl object-cover" />
      <div className="flex flex-col gap-5 rounded-2xl p-10 sm:p-12">
      <h4 className="text-2xl font-bold md:text-3xl">Award-Winning Salon</h4>
        <h2 className="text-3xl font-bold md:text-5xl">Hair Salon In Austin</h2>
        <p className="text-sm text-gray-500 sm:text-base">
          Aliquet risus feugiat in ante metus. Arcu dui vivamus arcu felis
          bibendum ut. Vestibulum lorem sed risus ultricies tristique nulla.
          Vitae et leo duis ut diam quam. Bibendum arcu vitae elementum
          curabitur vitae nunc. Dictumst vestibulum rhoncus est
          pellentesque. Lectus proin nibh nisl condimentum id. Ullamcorper
          dignissim cras tincidunt lobortis feugiat vivamus.
          <br />
          <br />
          Massa id neque aliquam vestibulum morbi blandit. Nulla
          pellentesque dignissim enim sit amet venenatis.
        </p>
      </div>
    </div>
  </div>
</section>


    {/* Services */}
   
<section>
  <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20">
  <h2 className="mx-auto max-w-2xl text-center text-2xl font-bold md:text-3xl mb-2 md:mb-2 lg:mb-4">
     Services
    </h2>
  <h2 className="mx-auto max-w-2xl text-center text-3xl font-bold md:text-5xl mb-8 md:mb-12 lg:mb-16">
     Services
    </h2>

    <div className="grid gap-0 sm:grid-cols-2 md:grid-cols-3">
      <a href="/" className="flex-col flex items-start justify-between border border-gray-300 p-10 h-72 hover:bg-black hover:text-white transition">
        <div className=" flex w-full items-center justify-between">
          <h5 className="text-xl font-bold">Zapier</h5>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 18L18 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M8.25 6H18V15.75" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </div>
        <div>
          <p>
            Lorem ipsum dolor sit amet consectetur adipiscing elit ut
            aliquam, purus sit.
          </p>
        </div>
      </a>
      <a href="/" className="flex-col flex items-start justify-between border border-gray-300 p-10 h-72 hover:bg-black hover:text-white transition">
        <div className=" flex w-full items-center justify-between">
          <h5 className="text-xl font-bold">Mailchimp</h5>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 18L18 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M8.25 6H18V15.75" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </div>
        <div>
          <p>
            Lorem ipsum dolor sit amet consectetur adipiscing elit ut
            aliquam, purus sit.
          </p>
        </div>
      </a>
      <a href="/" className="flex-col flex items-start justify-between border border-gray-300 p-10 h-72 hover:bg-black hover:text-white transition">
        <div className=" flex w-full items-center justify-between">
          <h5 className="text-xl font-bold">Airtable</h5>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 18L18 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M8.25 6H18V15.75" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </div>
        <div>
          <p>
            Lorem ipsum dolor sit amet consectetur adipiscing elit ut
            aliquam, purus sit.
          </p>
        </div>
      </a>
  
      <a href="/" className="flex-col flex items-start justify-between border border-gray-300 p-10 h-72 hover:bg-black hover:text-white transition">
        <div className=" flex w-full items-center justify-between">
          <h5 className="text-xl font-bold">Webflow</h5>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 18L18 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M8.25 6H18V15.75" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </div>
        <div>
          <p>
            Lorem ipsum dolor sit amet consectetur adipiscing elit ut
            aliquam, purus sit.
          </p>
        </div>
      </a>
      <a href="/" className="flex-col flex items-start justify-between border border-gray-300 p-10 h-72 hover:bg-black hover:text-white transition">
        <div className=" flex w-full items-center justify-between">
          <h5 className="text-xl font-bold">Zoho</h5>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 18L18 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M8.25 6H18V15.75" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </div>
        <div>
          <p>
            Lorem ipsum dolor sit amet consectetur adipiscing elit ut
            aliquam, purus sit.
          </p>
        </div>
      </a>
      <a href="/" className="flex-col flex items-start justify-between border border-gray-300 p-10  h-72 hover:bg-black hover:text-white transition">
        <div className=" flex w-full items-center justify-between">
          <h5 className="text-xl font-bold">Pipedrive</h5>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 18L18 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
            <path d="M8.25 6H18V15.75" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
        </div>
        <div>
          <p>
            Lorem ipsum dolor sit amet consectetur adipiscing elit ut
            aliquam, purus sit.
          </p>
        </div>
      </a>
    </div>
  </div>
</section>


    {/* Special Service */}
   
<section>
  <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20 bg-black">
    <div className="flex flex-col items-start gap-8 sm:gap-20 md:flex-row md:items-center">
      <div className="md:w-1/2">
        <h2 className="mb-4 max-w-3xl text-3xl font-bold md:text-5xl text-white">
          Never miss any task
        </h2>
        <p className="mb-6 max-w-lg text-sm text-white sm:text-base md:mb-10">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit ut
          aliquam, purus sit amet luctus venenatis, lectus
        </p>
        <a href="/" className="inline-block bg-red px-6 py-3 font-semibold text-white">
          Get started
        </a>
      </div>
      <div className="md:w-1/2">
        <img src="https://firebasestorage.googleapis.com/v0/b/flowspark-1f3e0.appspot.com/o/Tailspark%20Images%2FPlaceholder%20Image.svg?alt=media&token=375a1ea3-a8b6-4d63-b975-aac8d0174074" alt="" />
      </div>
    </div>
  </div>
</section>


    {/* Galley  */}
   
<section>
  <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20">
    <h2 className="mx-auto max-w-xl text-center text-3xl font-bold md:text-5xl mb-8 md:mb-12 lg:mb-16">
    What’s Hot
    </h2>
    <div className="grid grid-cols-1 gap-6 mb-6">
      <div className="bg-gray-100 p-6 rounded-lg flex flex-col md:flex-row md:justify-between items-center">
        <div className="flex flex-col gap-6">
          <div className="h-11 w-11">
            <svg className="h-11 w-11" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M41.3102 12.7222C41.3054 12.7222 41.3008 12.7203 41.2975 12.7169C41.2941 12.7136 41.2922 12.709 41.2922 12.7042C41.0325 12.262 40.6606 11.8963 40.2141 11.6441L24.4016 2.74954C23.9732 2.51034 23.4907 2.38477 23 2.38477C22.5094 2.38477 22.0269 2.51034 21.5984 2.74954L5.78595 11.6441C5.33947 11.8963 4.96754 12.262 4.70783 12.7042C4.70783 12.709 4.70593 12.7136 4.70256 12.7169C4.69919 12.7203 4.69462 12.7222 4.68986 12.7222V12.7581C4.44143 13.1768 4.31104 13.6549 4.31251 14.1417V31.8589C4.31342 32.3711 4.45031 32.8739 4.70918 33.3159C4.96806 33.7579 5.33964 34.1232 5.78595 34.3745L21.5984 43.2691C21.9965 43.4862 22.4391 43.6092 22.8922 43.6284H23.1438C23.5854 43.6089 24.0163 43.4858 24.4016 43.2691L40.2141 34.3745C40.6604 34.1232 41.032 33.7579 41.2908 33.3159C41.5497 32.8739 41.6866 32.3711 41.6875 31.8589V14.1417C41.6901 13.6434 41.5599 13.1534 41.3102 12.7222ZM23 5.24719L37.3211 13.2972L31.8227 16.4238L17.3219 8.42766L23 5.24719ZM23.1617 21.3472L8.69689 13.2972L14.375 10.0988L28.8938 18.0948L23.1617 21.3472ZM24.4555 39.9448L24.5992 23.8448L30.3672 20.5566V27.4027C30.3672 27.7839 30.5187 28.1495 30.7882 28.4191C31.0578 28.6887 31.4235 28.8402 31.8047 28.8402C32.1859 28.8402 32.5516 28.6887 32.8212 28.4191C33.0908 28.1495 33.2422 27.7839 33.2422 27.4027V18.9214L38.8125 15.7589V31.8589L24.4555 39.9448Z" fill="black" />
            </svg>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">
              Here is the title for this section
            </h3>
            <p className="text-gray-500 max-w-md">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
              do eiusmod tempor incididunt ut labore.
            </p>
          </div>
        </div>

        <div className="mt-5 md:mr-5 md:mt-5 pl-5">
          <img src="https://firebasestorage.googleapis.com/v0/b/flowspark-1f3e0.appspot.com/o/Tailspark%20Images%2FVector.png?alt=media&token=441fbdcd-c757-4be7-8a91-c4ef4c12d3d4" alt="" />
        </div>
      </div>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div className="bg-gray-100 p-6 rounded-lg flex flex-col space-y-4">
        <div className="h-6 w-6">
          <svg className="h-6 w-6" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M41.3102 12.7222C41.3054 12.7222 41.3008 12.7203 41.2975 12.7169C41.2941 12.7136 41.2922 12.709 41.2922 12.7042C41.0325 12.262 40.6606 11.8963 40.2141 11.6441L24.4016 2.74954C23.9732 2.51034 23.4907 2.38477 23 2.38477C22.5094 2.38477 22.0269 2.51034 21.5984 2.74954L5.78595 11.6441C5.33947 11.8963 4.96754 12.262 4.70783 12.7042C4.70783 12.709 4.70593 12.7136 4.70256 12.7169C4.69919 12.7203 4.69462 12.7222 4.68986 12.7222V12.7581C4.44143 13.1768 4.31104 13.6549 4.31251 14.1417V31.8589C4.31342 32.3711 4.45031 32.8739 4.70918 33.3159C4.96806 33.7579 5.33964 34.1232 5.78595 34.3745L21.5984 43.2691C21.9965 43.4862 22.4391 43.6092 22.8922 43.6284H23.1438C23.5854 43.6089 24.0163 43.4858 24.4016 43.2691L40.2141 34.3745C40.6604 34.1232 41.032 33.7579 41.2908 33.3159C41.5497 32.8739 41.6866 32.3711 41.6875 31.8589V14.1417C41.6901 13.6434 41.5599 13.1534 41.3102 12.7222ZM23 5.24719L37.3211 13.2972L31.8227 16.4238L17.3219 8.42766L23 5.24719ZM23.1617 21.3472L8.69689 13.2972L14.375 10.0988L28.8938 18.0948L23.1617 21.3472ZM24.4555 39.9448L24.5992 23.8448L30.3672 20.5566V27.4027C30.3672 27.7839 30.5187 28.1495 30.7882 28.4191C31.0578 28.6887 31.4235 28.8402 31.8047 28.8402C32.1859 28.8402 32.5516 28.6887 32.8212 28.4191C33.0908 28.1495 33.2422 27.7839 33.2422 27.4027V18.9214L38.8125 15.7589V31.8589L24.4555 39.9448Z" fill="black" />
          </svg>
        </div>
        <div>
          <h3 className="text-lg font-semibold mb-4">
            Here is the title for this section
          </h3>
          <p className="text-gray-500">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore.
          </p>
        </div>
      </div>
      <div className="bg-gray-100 p-6 rounded-lg flex flex-col space-y-4">
        <div className="h-6 w-6">
          <svg className="h-6 w-6" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M41.3102 12.7222C41.3054 12.7222 41.3008 12.7203 41.2975 12.7169C41.2941 12.7136 41.2922 12.709 41.2922 12.7042C41.0325 12.262 40.6606 11.8963 40.2141 11.6441L24.4016 2.74954C23.9732 2.51034 23.4907 2.38477 23 2.38477C22.5094 2.38477 22.0269 2.51034 21.5984 2.74954L5.78595 11.6441C5.33947 11.8963 4.96754 12.262 4.70783 12.7042C4.70783 12.709 4.70593 12.7136 4.70256 12.7169C4.69919 12.7203 4.69462 12.7222 4.68986 12.7222V12.7581C4.44143 13.1768 4.31104 13.6549 4.31251 14.1417V31.8589C4.31342 32.3711 4.45031 32.8739 4.70918 33.3159C4.96806 33.7579 5.33964 34.1232 5.78595 34.3745L21.5984 43.2691C21.9965 43.4862 22.4391 43.6092 22.8922 43.6284H23.1438C23.5854 43.6089 24.0163 43.4858 24.4016 43.2691L40.2141 34.3745C40.6604 34.1232 41.032 33.7579 41.2908 33.3159C41.5497 32.8739 41.6866 32.3711 41.6875 31.8589V14.1417C41.6901 13.6434 41.5599 13.1534 41.3102 12.7222ZM23 5.24719L37.3211 13.2972L31.8227 16.4238L17.3219 8.42766L23 5.24719ZM23.1617 21.3472L8.69689 13.2972L14.375 10.0988L28.8938 18.0948L23.1617 21.3472ZM24.4555 39.9448L24.5992 23.8448L30.3672 20.5566V27.4027C30.3672 27.7839 30.5187 28.1495 30.7882 28.4191C31.0578 28.6887 31.4235 28.8402 31.8047 28.8402C32.1859 28.8402 32.5516 28.6887 32.8212 28.4191C33.0908 28.1495 33.2422 27.7839 33.2422 27.4027V18.9214L38.8125 15.7589V31.8589L24.4555 39.9448Z" fill="black" />
          </svg>
        </div>
        <div>
          <h3 className="text-lg font-semibold mb-4">
            Here is the title for this section
          </h3>
          <p className="text-gray-500">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>


   {/* Galley */}
   
<section>
  <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20">
    <h2 className="text-center text-3xl font-bold md:text-5xl">
      Portfolio
    </h2>
    <p className="msm:text-base mb-8 mt-4 text-center text-sm text-gray-500 md:mb-12 lg:mb-16">
      Lorem ipsum dolor sit amet elit ut aliquam
    </p>
    <div className="mx-auto grid justify-items-stretch gap-2 md:grid-cols-3 lg:gap-10">
      <a href="/" className="relative flex h-[463px] justify-center items-center">
        <img src="https://firebasestorage.googleapis.com/v0/b/flowspark-1f3e0.appspot.com/o/Tailspark%20Images%2FPlaceholder%20Image.svg?alt=media&token=375a1ea3-a8b6-4d63-b975-aac8d0174074" alt="" className="inline-block h-full w-full rounded-lg object-cover" />
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex flex-col justify-center text-center rounded-lg">
          <p className="text-sm font-medium sm:text-xl">Project Name</p>
          <p className="text-sm sm:text-base">Web design</p>
        </div>
      </a>
      <a href="/" className="relative flex h-[463px] items-end">
        <img src="https://firebasestorage.googleapis.com/v0/b/flowspark-1f3e0.appspot.com/o/Tailspark%20Images%2FPlaceholder%20Image.svg?alt=media&token=375a1ea3-a8b6-4d63-b975-aac8d0174074" alt="" className="inline-block h-full w-full rounded-lg object-cover" />
      </a>
      <a href="/" className="relative flex h-[463px] items-end">
        <img src="https://firebasestorage.googleapis.com/v0/b/flowspark-1f3e0.appspot.com/o/Tailspark%20Images%2FPlaceholder%20Image.svg?alt=media&token=375a1ea3-a8b6-4d63-b975-aac8d0174074" alt="" className="inline-block h-full w-full rounded-lg object-cover" />
      </a>
      <a href="/" className="relative flex h-[463px] items-end">
        <img src="https://firebasestorage.googleapis.com/v0/b/flowspark-1f3e0.appspot.com/o/Tailspark%20Images%2FPlaceholder%20Image.svg?alt=media&token=375a1ea3-a8b6-4d63-b975-aac8d0174074" alt="" className="inline-block h-full w-full rounded-lg object-cover" />
      </a>
      <a href="/" className="relative flex h-[463px] items-end">
        <img src="https://firebasestorage.googleapis.com/v0/b/flowspark-1f3e0.appspot.com/o/Tailspark%20Images%2FPlaceholder%20Image.svg?alt=media&token=375a1ea3-a8b6-4d63-b975-aac8d0174074" alt="" className="inline-block h-full w-full rounded-lg object-cover" />
      </a>
      <a href="/" className="relative flex h-[463px] items-end">
        <img src="https://firebasestorage.googleapis.com/v0/b/flowspark-1f3e0.appspot.com/o/Tailspark%20Images%2FPlaceholder%20Image.svg?alt=media&token=375a1ea3-a8b6-4d63-b975-aac8d0174074" alt="" className="inline-block h-full w-full rounded-lg object-cover" />
      </a>
    </div>
  </div>
</section>


    {/* Newsletter */}
    
<section className="relative h-[100px] w-full">
  <div className="absolute bottom-0 w-full inset-x-0 mx-auto">
    <div className="w-full flex flex-col items-center bg-white border-t-2 border-black p-4 md:px-8 md:py-3 md:flex-row md:justify-between">
      <div className="flex items-center">
        <p>Ut enim odio quis ipsum posuere ante porta nibh nulla.</p>
      </div>
  
      <form name="email-form" method="get" className="relative mt-10 w-full max-w-md md:mt-0 flex flex-col md:flex-row gap-3 justify-center md:justify-end">
        <input type="email" className="w-full md:w-64 rounded-md border border-solid border-gray-300 px-3 py-2 text-sm text-black placeholder:text-black" placeholder="Enter your email" />
        <input type="submit" value="Subscribe" className="w-full md:w-auto cursor-pointer rounded-md bg-black px-6 py-2 text-center font-semibold text-white" />
      </form>
    </div>
  </div>
</section>


    {/* Footer */}
    
<footer className="block bg-purple-300">
  <div className="py-16 md:py-20 mx-auto w-full max-w-7xl px-5 md:px-10">
    <div className="flex-col flex items-center">
      <a href="/" className="mb-8 inline-block max-w-full text-black">
        <img src="https://assets.website-files.com/6458c625291a94a195e6cf3a/6458c625291a94d6f4e6cf96_Group%2047874-3.png" alt="" className="inline-block max-h-10" />
      </a>
      <div className="text-center font-semibold">
        <a href="/" className="inline-block px-6 py-2 font-normal text-black transition hover:text-blue-600">
          About
        </a>
        <a href="/" className="inline-block px-6 py-2 font-normal text-black transition hover:text-blue-600">
          Features
        </a>
        <a href="/" className="inline-block px-6 py-2 font-normal text-black transition hover:text-blue-600">
          Works
        </a>
        <a href="/" className="inline-block px-6 py-2 font-normal text-black transition hover:text-blue-600">
          Support
        </a>
        <a href="/" className="inline-block px-6 py-2 font-normal text-black transition hover:text-blue-600">
          Help
        </a>
      </div>
      <div className="mb-8 mt-8 border-b border-gray-300 w-48"></div>
      <div className="mb-12 grid-cols-4 grid-flow-col grid max-w-52 gap-8 mx-auto">
        <a href="/" className="mx-auto flex-col flex max-w-6 items-center justify-center text-black">
          <img src="https://assets.website-files.com/6458c625291a94a195e6cf3a/6458c625291a945b4ae6cf7b_Vector-1.svg" alt="" className="inline-block" />
        </a>
        <a href="/" className="mx-auto flex-col flex max-w-6 items-center justify-center text-black">
          <img src="https://assets.website-files.com/6458c625291a94a195e6cf3a/6458c625291a945560e6cf77_Vector.svg" alt="" className="inline-block" />
        </a>
        <a href="/" className="mx-auto flex-col flex max-w-6 items-center justify-center text-black">
          <img src="https://assets.website-files.com/6458c625291a94a195e6cf3a/6458c625291a940535e6cf7a_Vector-3.svg" alt="" className="inline-block" />
        </a>
        <a href="/" className="mx-auto flex-col flex max-w-6 items-center justify-center text-black">
          <img src="https://assets.website-files.com/6458c625291a94a195e6cf3a/6458c625291a9433a9e6cf88_Vector-2.svg" alt="" className="inline-block" />
        </a>
      </div>
      <p className="text-sm sm:text-base">
        © Copyright 2021. All rights reserved.
      </p>
    </div>
  </div>
</footer>



    <div>
<p className="hidden"> https://yvelisesbraidsalon.com</p>
</div>
  </div>
  )
}

export default GoogleMeSis